var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('b-loading',{attrs:{"active":_vm.isFullScreenSearching},on:{"update:active":function($event){_vm.isFullScreenSearching=$event}}}),(_vm.user_id)?_c('Header'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }